import { CanActivate, Router, UrlTree } from "@angular/router";
import { Injectable } from "@angular/core";
import { Observable, from } from "rxjs";
import { firstValueFrom, take } from "rxjs";
import { AuthService } from "./auth.service";

const ALLOWED_ROLES = ["superadmin", "admin", "manager", "worker"];

@Injectable()
export class AuthGuardDailySchedule implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(): Observable<boolean | UrlTree> {
    return from(this.guard());
  }

  private async guard(): Promise<boolean | UrlTree> {
    const userInfo = await firstValueFrom(this.authService.getAuthStatusListener().pipe(take(1)));
    const role = this.authService.getUserRole();
    if (!userInfo.isAuthenticated || !role || !ALLOWED_ROLES.includes(role)) {
      return this.router.createUrlTree(["/auth/unauthorized"]);
    }
    try {
      const profile = await firstValueFrom(this.authService.getProfile());
      if (!this.authService.isProfileComplete(profile)) {
        return this.router.createUrlTree(["/auth/complete-profile"]);
      }
      return true;
    } catch {
      return this.router.createUrlTree(["/auth/unauthorized"]);
    }
  }
}
